module.exports = __webpack_public_path__ + "img/violet_136.c0e1d126.png";